// extracted by mini-css-extract-plugin
export default {"last-seen":"dvo3Og0rI8","lastSeen":"dvo3Og0rI8"};